<template>
  <el-dialog :title="dialogMode === 'edit' ? '编辑代理商专链' : '新增代理商专链'" :visible.sync="localVisible" width="80%"
    @close="handleClose">
    <el-form v-loading="loading" :model="dialogForm" :rules="rules" ref="dialogForm" label-width="130px" size="small">
      <el-row>
        <el-col :span="12">
          <el-form-item label="选择代理商：" prop="agent">
            <el-select filterable v-model="dialogForm.agent" placeholder="现有代理商列表" class="full-width">
              <el-option v-for="item in agentOptions" :key="item.id" :label="item.label" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="专链类型：" prop="type1" label-width="130px" class="inline-selects">
            <el-select :disabled="dialogMode === 'edit'" v-model="dialogForm.type1" placeholder="请选择"
              class="type-select-left" @change="handleTypeChange">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-select :disabled="!dialogForm.type1 || dialogMode === 'edit'" v-model="dialogForm.type2"
              placeholder="请选择" class="type-select-right" :multiple="isMultiple" :key="isMultiple ? 'multi' : 'single'"
              filterable>
              <el-option v-for="item in productOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="dialogForm.type1 === 'combination'">
        <div class="combination-nums">
          <el-form-item v-for="(id, index) in dialogForm.type2" :key="id" :label="getProductName(id) + '：'"
            :prop="'number.' + id" :rules="{ required: true, message: '请输入数量', trigger: 'blur' }">
            <el-input v-model="dialogForm.number[id]" placeholder="请输入数量"></el-input>
          </el-form-item>
        </div>
      </template>
      <template v-if="dialogForm.type1 !== 'all'">
        <el-form-item label="专链名称：" prop="name" key="singleName">
          <el-input v-model="dialogForm.name" placeholder="请输入专链名称"></el-input>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item v-for="(id, index) in dialogForm.type2" :key="id" :label="'商品链接 ' + (index + 1) + '：'"
          :prop="'names.' + id" :rules="{ required: true, message: '请输入名称', trigger: 'blur' }">
          <el-input v-model="dialogForm.names[id]" placeholder="请输入专链名称"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="折扣力度：">
        <div class="discount-row" style="margin-top: 10px;" v-if="dialogForm.type1 == 'combination'">
          <el-radio v-model="dialogForm.discountType" label="bidAmount">指定金额</el-radio>
          <el-form-item prop="bidAmount" class="inline-item"
            :rules="dialogForm.discountType === 'bidAmount' ? { required: true, message: '请输入金额', trigger: 'blur' } : []">
            <el-input v-model="dialogForm.bidAmount" placeholder="" class="discount-input"
              :disabled="dialogForm.discountType !== 'bidAmount'"></el-input> 元
          </el-form-item>
        </div>
        <div class="discount-row">
          <el-radio v-model="dialogForm.discountType" label="reduce">立减</el-radio>
          <el-form-item prop="reduceAmount" class="inline-item"
            :rules="dialogForm.discountType === 'reduce' ? { required: true, message: '请输入金额', trigger: 'blur' } : []">
            <el-input v-model="dialogForm.reduceAmount" placeholder="" class="discount-input"
              :disabled="dialogForm.discountType !== 'reduce'"></el-input> 元
          </el-form-item>
        </div>
        <div style="margin-top: 10px;">
          <el-radio v-model="dialogForm.discountType" label="rate">专属折扣率</el-radio>
          <el-form-item prop="discountRate" class="inline-item"
            :rules="dialogForm.discountType === 'rate' ? { required: true, message: '请输入折扣率', trigger: 'blur' } : []">
            <el-input v-model="dialogForm.discountRate" placeholder="" class="discount-input"
              @input="val => dialogForm.discountRate = val.replace(/[^\d]/g, '')"
              :disabled="dialogForm.discountType !== 'rate'"></el-input> %
          </el-form-item>
        </div>
      </el-form-item>
      <el-form-item label="有效期：" prop="validDateRange">
        <el-date-picker v-model="dialogForm.validDateRange" type="datetimerange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH时" value-format="yyyy-MM-dd HH:00:00"
          :default-time="['00:00:00', '23:59:59']" popper-class="hour-only-picker" class="full-width"
          :append-to-body="false">
        </el-date-picker>
      </el-form-item>

      <template v-if="dialogForm.type1 === 'combination'">
        <el-form-item label="商品主图：" prop="pics">
          <div class="pics-box">
            <el-upload :action="uploadPicUrl" list-type="picture-card" :file-list="uploadPicList"
              accept=".png,.jpg,.jpeg" drag :on-preview="handlePicturesPreview" :on-remove="handlePicturesRemove"
              :on-success="handlePicturesSuccess" :on-error="handlePicturesError"
              :before-upload="handlePicturesBeforeUpload" :on-exceed="handlePicturesExceed" :limit="picsLimit">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <p class="tips">支持jpg、png格式，最多上传6张</p>
        </el-form-item>

        <el-form-item label="商品详情图：" prop="detailPics">
          <div class="pics-box pics-box-detail">
            <el-upload :action="uploadPicUrl" list-type="picture-card" :file-list="detailUploadPicList"
              accept=".png,.jpg,.jpeg" drag :on-preview="handleDetailPicturesPreview"
              :on-remove="handleDetailPicturesRemove" :on-success="handleDetailPicturesSuccess"
              :on-error="handleDetailPicturesError" :before-upload="handleDetailPicturesBeforeUpload">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <p class="tips">支持jpg、png格式，单张图片不超过2M</p>
        </el-form-item>
      </template>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitDialog" class="footer-btn">确认</el-button>
      <el-button @click="localVisible = false" class="footer-btn footer-btn-cancel">取消</el-button>
    </div>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="previewDialogShow" append-to-body custom-class="preview-image-dialog">
      <img width="100%" :src="previewDialogImageUrl" alt="">
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  BASE,
  agentCompanylistAll,
  commodityListAll,
  commodityAgentAdd,
  commodityAgentUpdateById
} from '@/common/api'
export default {
  name: 'AddDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogMode: {
      type: String,
      default: 'add'
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      typeOptions: [
        { label: '全产品', value: 'all' },
        { label: '单产品', value: 'single' },
        { label: '组合产品', value: 'combination' }
      ],
      editID: '',
      productOptions: [],
      agentOptions: [],
      dialogForm: {
        agent: '', // 选择的代理商ID
        type1: '', // 专链类型（全产品 all / 单产品 single）
        type2: '', // 选择的产品（全产品为数组，单产品为字符串）
        name: '', // 单产品模式下的专链名称
        names: {}, // 全产品模式下各产品的专链名称映射（以产品ID为key）
        number: {}, // 组合产品模式下各产品的数量映射（以产品ID为key）
        discountType: 'reduce', // 折扣类型（立减 reduce / 折扣率 rate / 指定金额 bidAmount）
        reduceAmount: '', // 立减金额
        bidAmount: '', // 指定金额
        discountRate: '', // 专属折扣率
        validDateRange: null, // 有效期时间范围数组 [开始时间, 结束时间]
        pic: '', // 商品图路径 (保留 pic 兼容旧逻辑，或统一改为 pics)
        pics: [], // 商品主图路径列表
        detailPics: [], // 商品详情图路径列表
      },
      uploadPicUrl: BASE + '/commodity/uploadPic', // 图片上传地址
      picsLimit: 6,
      uploadPicList: [],
      detailUploadPicList: [],
      previewDialogShow: false,
      previewDialogImageUrl: '',
      rules: {
        agent: [{ required: true, message: '请选择代理商', trigger: 'change' }],
        type1: [{ required: true, message: '请选择专链类型', trigger: 'change' }],
        type2: [{ required: true, message: '请选择产品', trigger: 'change' }],
        name: [{ required: true, message: '请输入专链名称', trigger: 'blur' }],
        validDateRange: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        pics: [{ type: 'array', required: true, message: '请上传商品主图', trigger: 'change' }],
        detailPics: [{ type: 'array', required: true, message: '请上传商品详情图', trigger: 'change' }]
      }
    }
  },
  computed: {
    localVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    // 判断是否为多选
    isMultiple() {
      return this.dialogForm.type1 !== 'single';
    }
  },
  watch: {
    async visible(val) {
      if (val) {
        await this.getAgentAndGoods();
        if (this.dialogMode === 'edit' && this.rowData) {
          console.log('正在编辑的数据:', JSON.stringify(this.rowData));
          const { rowData } = this;
          this.editID = rowData.id;
          this.dialogForm.name = rowData.name || '';
          this.dialogForm.agent = rowData.agentId || '';
          // 根据 API type 字段映射专链类型：1=全产品, 2=单产品, 3=组合产品
          const typeMap = { 1: 'all', 2: 'single', 3: 'combination' };
          this.dialogForm.type1 = typeMap[rowData.type] || 'single';
          // commodityId 是逗号分隔的字符串，需转为数字以匹配 el-select option
          if (this.dialogForm.type1 === 'single') {
            this.dialogForm.type2 = Number(rowData.commodityId) || '';
          } else {
            // 全产品 / 组合产品：转为数字数组
            this.dialogForm.type2 = (rowData.commodityId || '').split(',').filter(s => s).map(Number);
          }
          // 组合产品回显各商品数量
          if (this.dialogForm.type1 === 'combination' && rowData.productQuantity) {
            try {
              const quantityList = JSON.parse(rowData.productQuantity);
              const numberMap = {};
              quantityList.forEach(item => {
                numberMap[Number(item.commodityId)] = item.nums;
              });
              this.dialogForm.number = numberMap;
            } catch (e) {
              this.dialogForm.number = {};
            }
          }
          // 组合产品回显主图和详情图
          if (this.dialogForm.type1 === 'combination') {
            // 主图
            if (rowData.mainImage) {
              const mainPics = rowData.mainImage.split(',').filter(s => s);
              this.dialogForm.pics = mainPics;
              this.uploadPicList = mainPics.map((url, index) => ({
                name: '主图' + (index + 1),
                url: url
              }));
            }
            // 详情图
            if (rowData.detailDrawing) {
              const detailPics = rowData.detailDrawing.split(',').filter(s => s);
              this.dialogForm.detailPics = detailPics;
              this.detailUploadPicList = detailPics.map((url, index) => ({
                name: '详情图' + (index + 1),
                url: url
              }));
            }
          }
          // 处理折扣力度
          if (rowData.discountType === 1) {
            this.dialogForm.discountType = 'reduce';
            this.dialogForm.reduceAmount = rowData.discountValue;
            this.dialogForm.discountRate = '';
            this.dialogForm.bidAmount = '';
          } else if (rowData.discountType === 2) {
            this.dialogForm.discountType = 'rate';
            this.dialogForm.discountRate = rowData.discountValue;
            this.dialogForm.reduceAmount = '';
            this.dialogForm.bidAmount = '';
          } else if (rowData.discountType === 3) {
            this.dialogForm.discountType = 'bidAmount';
            this.dialogForm.bidAmount = rowData.discountValue;
            this.dialogForm.reduceAmount = '';
            this.dialogForm.discountRate = '';
          }
          // 有效期直接使用 startTime / endTime
          if (rowData.startTime && rowData.endTime) {
            this.dialogForm.validDateRange = [rowData.startTime, rowData.endTime];
          } else {
            this.dialogForm.validDateRange = null;
          }

        } else {
          // 新增模式，根据默认 type1 初始化 type2 类型
          this.handleTypeChange(this.dialogForm.type1);
        }
        this.$nextTick(() => {
          if (this.$refs.dialogForm) {
            this.$refs.dialogForm.clearValidate();
          }
        });
      }
    },
    'dialogForm.type2'(newVal) {
      if (Array.isArray(newVal)) {
        newVal.forEach(id => {
          if (!Object.prototype.hasOwnProperty.call(this.dialogForm.names, id)) {
            this.$set(this.dialogForm.names, id, '');
          }
          if (!Object.prototype.hasOwnProperty.call(this.dialogForm.number, id)) {
            this.$set(this.dialogForm.number, id, '');
          }
        });
      }
    }
  },
  methods: {
    // 图片预览
    handlePicturesPreview(file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },
    // 图片移除
    handlePicturesRemove(file, fileList) {
      this.uploadPicList = fileList;
      this.dialogForm.pics = fileList.map(item => {
        if (item.response && item.response.data) return item.response.data.url;
        return item.url;
      });
      this.$refs.dialogForm.validateField('pics');
    },
    // 图片上传成功
    handlePicturesSuccess(res, file, fileList) {
      if (res.code == 0) {
        this.uploadPicList = fileList;
        this.dialogForm.pics = fileList.map(item => {
          if (item.response && item.response.data) return item.response.data.url;
          return item.url;
        });
        this.$refs.dialogForm.validateField('pics');
      } else {
        this.$message.error(res.msg || '上传失败');
      }
    },
    // 图片上传失败
    handlePicturesError(err, file, fileList) {
      this.$message.error('上传图片发生错误');
    },
    // 图片上传前校验
    handlePicturesBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    // 图片数量超限
    handlePicturesExceed(files, fileList) {
      this.$message.warning('最多只能上传 6 张图片');
    },
    // --- 详情图相关方法 ---
    handleDetailPicturesPreview(file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },
    handleDetailPicturesRemove(file, fileList) {
      this.detailUploadPicList = fileList;
      this.dialogForm.detailPics = fileList.map(item => {
        if (item.response && item.response.data) return item.response.data.url;
        return item.url;
      });
      this.$refs.dialogForm.validateField('detailPics');
    },
    handleDetailPicturesSuccess(res, file, fileList) {
      if (res.code == 0) {
        this.detailUploadPicList = fileList;
        this.dialogForm.detailPics = fileList.map(item => {
          if (item.response && item.response.data) return item.response.data.url;
          return item.url;
        });
        this.$refs.dialogForm.validateField('detailPics');
      } else {
        this.$message.error(res.msg || '上传失败');
      }
    },
    handleDetailPicturesError(err, file, fileList) {
      this.$message.error('上传图片发生错误');
    },
    handleDetailPicturesBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    getProductName(id) {
      const product = this.productOptions.find(item => item.id === id);
      return product ? product.label : '未知商品';
    },
    handleTypeChange(val) {
      if (val !== 'single') {
        this.dialogForm.type2 = [];
        this.dialogForm.names = {};
        this.dialogForm.number = {};
        this.dialogForm.name = '';
      } else {
        this.dialogForm.type2 = '';
        this.dialogForm.names = {};
      }
    },
    async getAgentAndGoods() {
      if (this.loading) return;
      this.loading = true;

      try {
        const [agentRes, commodityRes] = await Promise.all([
          agentCompanylistAll({
            type: 1,
          }),
          commodityListAll({
            status: 1,
            isJoinGoods: '0',
          })
        ]);

        this.agentOptions = agentRes.data.map(item => ({
          label: item.name,
          id: item.id
        }));
        this.productOptions = commodityRes.data.map(item => ({
          label: item.name,
          id: item.id,
          price: item.price
        }));
      } catch (error) {
        this.$message.error('获取代理商或商品列表失败');
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      // 手动重置，用了动态 prop，但 resetFields() 找不到对应的字段，导致报错
      this.dialogForm = {
        agent: '',
        type1: '',
        type2: '',
        name: '',
        names: {},
        discountType: 'reduce',
        reduceAmount: '',
        bidAmount: '',
        discountRate: '',
        validDateRange: null,
        number: {},
        pics: [],
        detailPics: []
      }
      this.uploadPicList = [];
      this.detailUploadPicList = [];
    },
    submitDialog() {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          const {
            dialogForm
          } = this;
          // 组装后端要求的格式
          let apiType = 2; // 默认单产品
          if (dialogForm.type1 === 'all') {
            apiType = 1;
          } else if (dialogForm.type1 === 'combination') {
            apiType = 3;
          }

          const discountMapping = { reduce: 1, rate: 2, bidAmount: 3 };
          const valueMapping = {
            reduce: dialogForm.reduceAmount,
            rate: dialogForm.discountRate,
            bidAmount: dialogForm.bidAmount
          };

          const params = {
            agentId: dialogForm.agent,
            type: apiType,
            commodityAgentNameCommodityIdList: [],
            discountType: discountMapping[dialogForm.discountType],
            discountValue: Number(valueMapping[dialogForm.discountType]),
            startTime: dialogForm.validDateRange ? dialogForm.validDateRange[0] : '',
            endTime: dialogForm.validDateRange ? dialogForm.validDateRange[1] : '',
            mainImage: dialogForm.pics.join(','),
            detailDrawing: dialogForm.detailPics.join(','),
            state: 1, // 示例状态
          };
          // 处理商品列表
          if (this.isMultiple) {
            // 新增
            if (apiType !== 3) {
              params.commodityAgentNameCommodityIdList = dialogForm.type2.map(id => ({
                commodityId: id,
                name: dialogForm.names[id],
                // price: (this.productOptions.find(item => item.id === id) || {}).price
              }));
            } else {
              params.commodityAgentNameCommodityIdList = [{
                commodityId: dialogForm.type2.join(','),
                name: dialogForm.name,
                // price: this.productOptions.map(item => item.price)
              }];
              params.productQuantity = JSON.stringify(Object.entries(dialogForm.number).reduce((acc, [key, value]) => {
                if (value) {
                  acc.push({
                    commodityId: key,
                    nums: value
                  });
                }
                return acc;
              }, []))
            }
          } else {
            //编辑
            params.commodityAgentNameCommodityIdList = [{
              commodityId: dialogForm.type2,
              name: dialogForm.name,
              price: (this.productOptions.find(item => item.id === dialogForm.type2) || {}).price
            }];
          }
          const minPrice = Math.min(...params.commodityAgentNameCommodityIdList.map(item => item.price));
          if ((params.discountType === 1 && params.discountValue >= minPrice)) {
            this.$message.error('折扣值不能大于等于商品价格');
            return;
          }
          // discountRate 不能大于100，不能小于等于0
          if (params.discountType === 2 && (params.discountValue > 100 || params.discountValue <= 0)) {
            this.$message.error('折扣率不能大于100，不能小于等于0');
            return;
          }
          if (params.discountType === 3 && (params.discountValue <= 0)) {
            this.$message.error('金额必须大于0');
            return;
          }
          this.loading = true;
          try {
            const res = await (this.dialogMode === 'edit' ? commodityAgentUpdateById({ id: this.editID, ...params, ...params.commodityAgentNameCommodityIdList[0] }) : commodityAgentAdd(params));
            if (res.code === 0) {
              const msg = this.dialogMode === 'edit' ? '修改成功' : '创建成功';
              this.$message.success(msg);
              this.$emit('success');
              this.localVisible = false;
            } else {
              this.$message.error(res.msg || '提交失败');
            }
          } catch (error) {
            this.$message.error('网络请求失败，请稍后再试');
          } finally {
            this.loading = false;
          }
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../common/styles/base/mixin-font";
@import "../../../../common/styles/base/mixin-common";

.full-width {
  width: 100%;
}

.type-select-left {
  width: 48%;
  margin-right: 2%;
}

.type-select-right {
  width: 50%;
}

.combination-nums {
  :deep(.el-form-item) {
    display: flex;

    .el-form-item__label {
      width: auto !important;
      float: none !important;
      white-space: nowrap;
    }

    .el-form-item__content {
      margin-left: 0px !important;
      flex: 1;
    }
  }
}

.discount-row {
  margin-bottom: 10px;
}

.discount-input {
  width: 120px;
  margin: 0 10px;
}

.pics-box {
  display: flex;
  flex-wrap: wrap;

  :deep(.el-upload-list--picture-card) {
    .el-upload-list__item {
      position: relative;
      width: 100px;
      height: 100px;
      border-radius: 2px;
      transition: none;

      .el-upload-list__item-thumbnail {
        @include position(absolute, none, 50%, none, none, 50%);
        @include translate(-50%, -50%, 0);
      }

      .el-progress {
        width: 80px;
        height: 80px;

        .el-progress-circle {
          width: 80px !important;
          height: 80px !important;
        }
      }

      .el-icon-close-tip {
        display: none;
      }
    }
  }

  :deep(.el-upload--picture-card) {
    width: 100px;
    height: 100px;
    line-height: 98px;
    border-radius: 2px;
    background: #FFF;

    .el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;
      background: transparent;

      .el-icon-plus {
        font-size: 18px;
        color: #8c939d;
      }
    }

    &:hover {
      border-color: $themeColor;

      .el-icon-plus {
        color: $themeColor;
      }
    }
  }
}

.dialog-footer {
  text-align: center;
}

.footer-btn {
  width: 120px;
}

.footer-btn-cancel {
  margin-left: 30px;
}

.inline-selects {
  :deep(.el-form-item__content) {
    display: flex;
  }
}

.inline-item {
  display: inline-block;
  margin-bottom: 0 !important;
  vertical-align: middle;
}
</style>
